import React from 'react';

import styled from 'styled-components';

import CtaButton from 'components/CtaButton/CtaButton';
import InnerHtml from 'components/InnerHtml/InnerHtml';

import { TabTableTabI } from 'interfaces/content-stack/modular-blocks/tabTable';

import { getModularBlockLink } from 'utils/modularBlockUtils';

const TabFooterContainer = styled.div`
  grid-row-gap: 0.5rem;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 1.5rem;
  display: flex;
`;

const Disclaimer = styled.div`
  font-size: 0.875rem;
  font-family: ${(props) => props.theme.fonts.default};
  color: ${(props) => props.theme.colors.primaryBlack};
  font-weight: 500;
  line-height: 1.5;
`;

interface TabFooterProps {
  tab: TabTableTabI;
}

function TabFooter({ tab }: TabFooterProps) {
  return (
    <TabFooterContainer>
      {tab.disclaimer && (
        <Disclaimer>
          <InnerHtml richText={tab.disclaimer} />
        </Disclaimer>
      )}
      {tab.buttonCta && (
        <CtaButton
          to={getModularBlockLink(tab.buttonCta.buttonLink)}
          buttonType={tab.buttonCta.buttonType}
          text={tab.buttonCta.buttonText}
          openInNewWindow={!!tab.buttonCta.buttonLink[0]?.openInNewWindow}
        />
      )}
    </TabFooterContainer>
  );
}

export default React.memo(TabFooter);
